import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import { CuboidBase, CuboidState } from '../types';

export const useResetCurrentCuboidRotation = <CuboidT extends CuboidBase>(
  cuboidState: CuboidState<CuboidT>
) => {
  const setCurrentCuboid = useSetAtom(cuboidState.currentCuboid);

  const resetCurrentCuboidRotation = useCallback(() => {
    setCurrentCuboid((currentCuboid) => {
      if (!currentCuboid) return currentCuboid;
      const [r, p, y] = currentCuboid.rotation;
      if (r === 0 && p === 0 && y === 0) return currentCuboid;
      return { ...currentCuboid, rotation: [0, 0, 0] };
    });
  }, [setCurrentCuboid]);

  return resetCurrentCuboidRotation;
};
